import React from 'react';
import { useTranslation } from 'react-i18next';

import { styled } from '@mui/material';

import { Link } from 'Components';
import { urls } from 'Router';

const Container = styled('span')`
  display: flex;
  gap: 5px;
`;

export const AcceptTermsAndPrivacyPolicyMessage = () => {
  const { t } = useTranslation();

  return (
    <Container>
      {t('auth.acceptTermsPart1')}{' '}
      <Link to={urls.regulationsPage} label={t('auth.termsOfUse')} shouldOpenInNewTab={false} />{' '}
      {t('auth.acceptTermsPart2')}{' '}
      <Link
        to={urls.privacyPolicyPage}
        label={t('auth.privacyPolicy')}
        shouldOpenInNewTab={false}
      />
    </Container>
  );
};
